module.exports = __webpack_public_path__ + "images/help/plane@2x-d69710963421d092b2a11b38d6172b64.png";